import React from "react";

const facebookIcon = () => {
  return (
    <svg
      width="11"
      height="24"
      viewBox="0 0 11 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="facebook-icon"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.31403 24V11.9986H10.5683L10.9995 7.86284H7.31403L7.31956 5.79286C7.31956 4.71419 7.42023 4.13622 8.94207 4.13622H10.9765V0H7.72179C3.81239 0 2.43638 2.00628 2.43638 5.38022V7.86331H-0.000488281V11.9991H2.43638V24H7.31403Z"
        fill="white"
      />
    </svg>
  );
};

export default facebookIcon;

// facebookIcon() {
//   return (
//     <svg
//       width="11"
//       height="24"
//       viewBox="0 0 11 24"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         fillRule="evenodd"
//         clipRule="evenodd"
//         d="M7.31403 24V11.9986H10.5683L10.9995 7.86284H7.31403L7.31956 5.79286C7.31956 4.71419 7.42023 4.13622 8.94207 4.13622H10.9765V0H7.72179C3.81239 0 2.43638 2.00628 2.43638 5.38022V7.86331H-0.000488281V11.9991H2.43638V24H7.31403Z"
//         fill="white"
//       />
//     </svg>
//   );
// }
//
